import { useState } from "react";
import { BadgeCheck, Calendar, Share2 } from "lucide-react";
import ShareCardDialog from "@/components/ShareCardDialog";

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

export default function ProblemListItem({ problem, index = 0, person }) {
  const [shareOpen, setShareOpen] = useState(false);
  return (
    <article
      data-testid={`problem-item-${index}`}
      className="py-6 border-b border-[#F3F4F6] last:border-0"
    >
      <div className="flex items-start gap-4">
        <span className="mt-1 flex-shrink-0 w-8 h-8 rounded-full bg-[#FFF3E0] text-[#B45309] flex items-center justify-center font-display font-semibold text-sm">
          {String(index + 1).padStart(2, "0")}
        </span>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-4">
            <h3 className="font-display font-semibold text-lg text-[#111827] leading-snug">
              {problem.title}
            </h3>
            <div className="flex items-center gap-2 flex-shrink-0">
              <span
                className="inline-flex items-center gap-1 text-xs font-semibold text-[#0F766E] bg-[#ECFDF5] px-2 py-1 rounded-full"
                title="Listed solution"
              >
                <BadgeCheck size={12} />
                Solution
              </span>
              {person && (
                <button
                  onClick={() => setShareOpen(true)}
                  data-testid={`share-problem-${index}`}
                  aria-label="Share this solution"
                  className="w-7 h-7 rounded-full flex items-center justify-center text-[#9CA3AF] hover:text-[#3FFFB6] hover:bg-[#D6FFEB] transition-colors"
                >
                  <Share2 size={13} />
                </button>
              )}
            </div>
          </div>

          <p className="mt-2 text-[#4B5563] leading-relaxed">
            {problem.description}
          </p>

          {problem.outcome && (
            <div className="mt-3 rounded-xl bg-[#FAFAFA] ring-1 ring-[#F3F4F6] px-4 py-3">
              <p className="text-xs font-semibold uppercase tracking-wider text-[#9CA3AF] mb-1">
                Outcome
              </p>
              <p className="text-sm text-[#111827] font-medium leading-snug">
                {problem.outcome}
              </p>
            </div>
          )}

          <div className="mt-4 flex flex-wrap items-center gap-2">
            {problem.categories?.map((c) => (
              <span
                key={c}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#F3F4F6] text-[#4B5563]"
              >
                {c}
              </span>
            ))}
            {problem.tools?.map((t) => (
              <span
                key={t}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
              >
                {t}
              </span>
            ))}
          </div>

          {problem.dateSolved && (
            <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-[#9CA3AF]">
              <Calendar size={12} />
              Solved {formatDate(problem.dateSolved)}
            </p>
          )}
        </div>
      </div>
      {person && (
        <ShareCardDialog
          open={shareOpen}
          onOpenChange={setShareOpen}
          person={person}
          problem={problem}
        />
      )}
    </article>
  );
}
